"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processNotifyMeNotifications = void 0;
const helpers_1 = require("../../helpers");
const formatDateFriendly_1 = require("../formatDateFriendly");
const sendEmail_1 = require("../sendEmail");
const processNotifyMeNotifications = async (supabase) => {
    const { data, error } = await supabase.rpc("process_notify_me", {});
    if (error) {
        return error;
    }
    // for each subscriber, send an email
    for (const subscriber of data) {
        const logo = JSON.parse(subscriber?.agent_logo || "");
        const email_obj = {
            agent: {
                id: subscriber.agent_id,
                logo: `https://golfsavers.b-cdn.net${logo.url}`,
                name: subscriber.agent_name,
                email: subscriber.agent_email,
                phone: subscriber.agent_phone,
            },
            source_url: subscriber.source_url,
            course_name: subscriber.course_name.en,
            requested_date: (0, formatDateFriendly_1.formatDateFriendly)(subscriber.date),
        };
        // is the subscriber.date in th epast?  If so, we need to send a different email
        const date = new Date(subscriber.date);
        const today = new Date();
        // email support with request details
        const request_support_email = {
            language_code: "en",
            template_id: date < today || subscriber.is_future
                ? helpers_1.NOTIFY_ME_TEE_TIME_PAST
                : helpers_1.NOTIFY_ME_TEE_TIME_AVAILABLE,
            data: email_obj,
            agent_id: subscriber.agent_id,
            email_address: subscriber.email,
        };
        await (0, sendEmail_1.sendEmail)(request_support_email);
    }
    return data;
};
exports.processNotifyMeNotifications = processNotifyMeNotifications;
